import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IndexCard } from '../../../auth/store/models';
import { TimeBudgetView } from '../../models/timebudgetView';
import { ResourceplanComponent } from '../../../clients/client-details/sager/sag-faner/resourceplan/resourceplan.component';

@Component({
    selector: 'app-statistik-sag-ui',
    templateUrl: './statistik-modal-sag.component.html',
    styleUrls: ['./statistik-modal-sag.component.scss'],
    standalone: false
})
export class StatistikKunderSagModalComponent {
    @Input() timebudgets: TimeBudgetView[];
    @Input() userCards: IndexCard[];
    @Input() medID: number;
    @Input() month: any;
    @Input() year: number;
    @Output() reloadTimebudget = new EventEmitter();

    hasChanged = false;
    selectedTimeBudget: TimeBudgetView;

    constructor(
        private activeModal: NgbActiveModal,
        private modal: NgbModal,
    ) {}

    onDismiss() {
        this.activeModal.close(this.hasChanged);
    }

    onSelectTimeBudget(timeBudget: TimeBudgetView) {
        const rplanModal = this.modal.open(ResourceplanComponent, { size: 'lg' });
        rplanModal.componentInstance.sagId = timeBudget.sagID;
        rplanModal.componentInstance.isModal = true;
        rplanModal.result.then(() => {
            this.hasChanged = true;
            this.reloadTimebudget.emit();
        }).catch(() => {
            this.hasChanged = true;
            this.reloadTimebudget.emit();
        });
    }

    findName(brugerID: number): string {
        let name = '';

        const foundCard = this.userCards.find(card => card.cardId === brugerID);

        if (foundCard) {
            name = `${foundCard.fornavn} ${foundCard.efternavn}`;
        }
        return name;
    }

    findInit(medID: number) {
        return this.userCards?.find(card => card.cardId === medID)?.brugerId;
    }
}
